module.exports = __webpack_public_path__ + "img/enabled.0e768209.svg";